export const SOCIAL_NETWORKS_NAMES = {
  GITHUB: 'github',
  LINKEDIN: 'linkedin',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  TELEGRAM: 'telegram'
}
